module.exports = __webpack_public_path__ + "49a9bcdd9b30e60e7b6126c54ec483d1.pdf";